<template>
    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">审核操作</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="auditState">
                        <el-radio-group v-model="ruleForm.auditState">
                            <el-radio label="1">通过</el-radio>
                            <el-radio label="-1">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="ruleForm.auditState == '1' && assetType != 2">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value">
                    <div class="pos-rel">
                        <el-checkbox v-model="isStarted">领用即启用</el-checkbox>
                    </div>
                </div>
            </div>
            <div v-if="isStarted && ruleForm.auditState && assetType != 2">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">启用日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-date-picker v-model="startDate" type="date" placeholder="选择日期"></el-date-picker>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    export default {
        name: 'swb-app-return-voucher-audit',
        desc: '领用归还单审核',
        props: {
            updateOrgNetWorth: {
                type: Boolean,
                default: true
            },
            updateFiscalAcctFlag: {
                type: Boolean,
                default: false
            },
            assetType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                ruleForm: {
                    auditState: "1"
                },
                acctEnterWayList: [],
//                acctEnterWay: 0,    // 未知
                isStarted: false,
                startDate: new Date(),
            }
        },
        created: function () {
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.acctEnterWayList = getEnumList("acctEnterWay");    // 购置方式
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                let ruleForm = self.ruleForm;
//                ruleForm.acctEnterWay = self.acctEnterWay;
                ruleForm.isState = self.isStarted;
                if(!Utils.isNoB(self.startDate)) {
                    ruleForm.startDate = self.startDate.format("yyyy-MM-dd:HH:mm:dd");
                } else if(self.isStarted && ruleForm.auditState) {
                    result.type = 'warn';
                    result.message = "请输入启用日期";
                    return result;
                }
                result.data = ruleForm;
                return result;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceAppReturnVoucherAudit.vue